// import FloatingLabel from "react-bootstrap/FloatingLabel";
import React, { useRef, useState, useEffect, useContext } from "react";
import { Row, Col, Button, ListGroup } from "react-bootstrap";
import TextArea from "../../../../components/TextArea";
import Input from '../../../../components/Input';

import { Form } from "@unform/web";
import * as Yup from "yup";
import { SubmitHandler, FormHandles } from "@unform/core";
import { ToastContext } from "../../../../contexts/toast/toastContext";
import { getSingleErrorMessage } from "../../../../helpers/getSingleErrorMessage";
import api from "../../../../services/api";
import getValidationErrors from "../../../../helpers/getValidateErrors";
import { useAuth } from "../../../../hooks/auth";
import { ITermo } from "../../../../interfaces/termo.interface";
import { SweetAlertContext } from "../../../../contexts/sweetAlert/alertContext";

const Termo: React.FC = () => {
  //Ref
  const formRef = useRef<FormHandles>(null);

  //Context
  const toastContext = useContext(ToastContext);
  const sweetAlert = useContext(SweetAlertContext);

  //States
  const [reload, setReload] = useState(false);
  const [listaDeTermos, setListaDeTermos] = useState<ITermo[]>([]);
  const [termoSelecionado, setTermoSelecionado] = useState<number | null>(null);
  const [showModalTermo, setShowModalTermo] = useState(false);
  const [isCriandoNovoTermo, setIsCriandoNovoTermo] = useState<boolean>(false);
  
  //Parâmetros
  const { user } = useAuth();

  //Effects
  useEffect(() => {
    (async () => {
      try {
        const { data: termo } = await api.get(`/Termo/padrao/fabricante/${user?.fabricanteId}`);
        if(termo) {
          setTermoSelecionado(termo.termoId);
          termo.nome && formRef.current?.setFieldValue("nome", termo.nome);
          termo.texto && formRef.current?.setFieldValue("texto", termo.texto);
        
        }
        const response = await api.get("/Termo/ObterTermosDoFabricante");
        if (response.data) {
          setListaDeTermos(response.data);
        }

      } catch (error) {
        const message = getSingleErrorMessage(error);
        if (message) {
          toastContext.notification(message, "warn");
        } else {
          toastContext.notification(
            "Ocorreu um erro ao realizar essa operação.",
            "error"
          );
        }
      }
    })();
  }, [reload, user]);

  //Handles

  const handleSelecionarTermo = (termo: ITermo) => {
    setTermoSelecionado(termo.termoId);
    formRef.current?.setFieldValue("nome", termo.nome);
    formRef.current?.setFieldValue("texto", termo.texto);
    setIsCriandoNovoTermo(false); 
  };

  const handleNovoTermo = () => {
    formRef.current?.clearField('nome');
    formRef.current?.clearField('texto');
    setTermoSelecionado(null);
    setIsCriandoNovoTermo(true); 
  };

  const handleSubmit: SubmitHandler = async (data, { reset }) => {
    try {
      formRef.current?.setErrors({});

      const message = "Esse campo não pode ficar vazio.";
      const schema = Yup.object().shape({
        nome: Yup.string().required(message),
        texto: Yup.string().required(message),
      });

      await schema.validate( formRef.current?.getData(), { abortEarly: false });
      
      //Passou pela validação
      const dadosTermos = {
        nome:  formRef.current?.getData().nome,
        texto: formRef.current?.getData().texto,
        padrao: true,
      };
      
      if (termoSelecionado && !isCriandoNovoTermo) {
        const dadosTermos = {
          nome: data.nome,
          texto: data.texto,
          termoId: termoSelecionado,
          padrao: true,
        };
        await api.put("/Termo", dadosTermos);
        toastContext.notification("Termo Atualizado.", "success");
      } else {
         const dadosTermos = {
          nome: data.nome,
          texto: data.texto,
          padrao: true,
        };
        await api.post("/Termo", dadosTermos);
        toastContext.notification("Termo Criado.", "success");
      }
      setReload(prevState => !prevState);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        formRef.current?.setErrors(getValidationErrors(err));
      } else {
        const message = getSingleErrorMessage(err);
        if (message) {
          toastContext.notification(message, "error");
        } else {
          toastContext.notification(
            "Ocorreu um erro ao realizar essa operação.",
            "error"
          );
        }
      }
    }
  };

  return (
    <>
      <div className="card personalizacao-termo">
        <div className="card-header">
          <Row>
            <h3 className="card-title">Termo de Uso | Garantia</h3>
          </Row>
        </div>
        <div className="card-body">
          <Row style={{ height: "300px" }}>
            <Col md={4}>
              {listaDeTermos.length > 0 ? (
                <>
                <div>Lista dos termos | garantia</div>
                <ListGroup style={{ maxHeight: "280px", overflowY: "auto", marginTop: "10px" }}>
                  {listaDeTermos.map((termo) => (
                    <div className="mb-1" key={termo.termoId}>
                      <ListGroup.Item
                        key={termo.termoId}
                        action
                        onClick={() => handleSelecionarTermo(termo)}
                        active={termoSelecionado === termo.termoId}
                      >
                        {termo.nome}
                      </ListGroup.Item>
                    </div>
                  ))}
                </ListGroup>
                </>
              ) : (
                <div className="text-center align-items-center justify-content-center flex-column d-flex h-100">
                  <p>Nenhum registro encontrado.</p>
                </div>
              )}
            </Col>
            <div className="vr" />
            <Col md={7}> 
              <Form ref={formRef} onSubmit={handleSubmit}>
                  <div className="form-group">
                      <Input name="nome" type="text" label="Título" placeholder="Digite um título..." maxLength={120}/>
                  </div>
                  <div className="form-group">
                    <TextArea
                      name="texto"
                      placeholder="Digite um texto..."
                      className="form-control"
                      maxLength={8000}
                      rows={8}
                    />
                  </div>
              </Form>              
            </Col>
          </Row>
        </div>
        <div className="card-footer text-right col-xs-12 col-sm-12 col-md-12">
        <Button
            variant="secondary"
            title="Novo Termo"
            onClick={handleNovoTermo}
            className="mr-2"
          >
            <i className="fa fa-plus mr-2"></i>Novo Termo | Garantia
          </Button>
          <Button
            variant="primary"
            title="Editar Termo"
            onClick={() => formRef.current?.submitForm()}
          >
            <i className="fa fa-save mr-2"></i>Salvar Termo | Garantia
          </Button>
        </div>                    
      </div>
    </>
  );
};

export default Termo;
